import _ from 'underscore';
import Radio from 'backbone.radio';
import strings_specific from 'amdi18n-loader!@/nls/device_group_list';
import strings_common from 'amdi18n-loader!@/nls/common';
var strings             = _.extend({}, strings_common, strings_specific);

var globalCh = Radio.channel('global');

function title(devicegroup) {
    return devicegroup.get('name') + ' Test DUT Devices';
}

var child_view_options = {
    show: {
        type: false,
        rel_owner: true,
        rel_account: false,
        rel_product: false,
        rel_devicegroup: false,
        action_restart: true,

    }
};
var columns = [{
    name: '',
    class_name: 'select',
    sortable: false,
    select_all: true
}, {
    name: strings.device_id,
    class_name: 'name',
    sortable: false,
}, {
    name: 'Owner',
    class_name: 'owner',
    sortable: false
}, {
    name: 'Status',
    class_name: 'status',
    sortable: false,
}, {
    name: 'Last Enrolled',
    class_name: 'enrolled',
    sortable: false,
    sort_by: 'last_blinkup_at'
}, {
    name: 'Manage'
}
];

function show_pre_dut_devices(devicegroup) {
    function show_devices() {
        globalCh.request(
            'show_devices',
            {
                devicegroup: devicegroup,
                product: devicegroup.rel.get('product')
            },
            columns,
            title(devicegroup),
            child_view_options
        );
    }

    show_devices();
}

export default show_pre_dut_devices;


